// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2UPZd","upload":"Small_upload__1GlX9","imageWrap":"Small_imageWrap__VFYoX","removeBtn":"Small_removeBtn__7p4nw"};